import DealNode from "./DealNode"

const FlowNodes = (props) => {
    switch(props.type) {
        case 'deal': return <DealNode {...props} />;
        default: return <div></div>;
    }
}

export default FlowNodes;